import { DownOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { DropdownHeader } from '../../../Header/Header.styles';

export const ProfileDropdownHeader = styled(DropdownHeader)`
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.15s ease;
`;

export const DownArrow = styled(DownOutlined)`
  color: ${(props) => props.theme.colors.text.secondary};

  @media only screen and ${(props) => props.theme.media.md} {
    color: ${(props) => props.theme.colors.text.main};
  }
`;
